import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createUserNoticesSubscribeFormReduceObject } from '../../../common/reducers/userNoticesSubscribeForm';
import { createReduceObject as createUserNoticesSetReadFormReduceObject } from '../../../common/reducers/userNoticesSetReadForm';

import userNoticesSubscribeFormSaga from './sagas/userNoticesSubscribeFormSaga';
import userNoticesSetReadFormSaga from './sagas/userNoticesSetReadFormSaga';

export default [
  // Forms
  ...createCombineMapItem(
    'userNoticesSubscribeForm',
    createUserNoticesSubscribeFormReduceObject,
    [userNoticesSubscribeFormSaga]
  ),
  ...createCombineMapItem(
    'userNoticesSetReadForm',
    createUserNoticesSetReadFormReduceObject,
    [userNoticesSetReadFormSaga]
  )
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/events/reducers/static/forms/reducersMap.js